import { cx } from '@linaria/core';
import { Ribbon } from './atom.ribbon.js';
import { headerCls, ribbonCls, headingCls, spanCls, descriptionCls } from './header.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Header(props) {
  const displayHeader = !!props.title || !!props.description;
  if (!displayHeader) {
    return null;
  }
  return /*#__PURE__*/jsxs("header", {
    className: cx(headerCls, props.scrambled && "scrambled"),
    children: [/*#__PURE__*/jsx(Ribbon, {
      ident: props.ribbonIconId,
      className: ribbonCls
    }), /*#__PURE__*/jsxs("div", {
      children: [!!props.title && /*#__PURE__*/jsx("h1", {
        className: cx(headingCls, spanCls),
        children: props.title
      }), !!props.description && /*#__PURE__*/jsx("div", {
        className: cx(descriptionCls, spanCls),
        children: props.description
      })]
    })]
  });
}

export { Header };
//# sourceMappingURL=header.js.map
